import $ from 'jquery';
import {Dialog} from "../Libraries/Dialog";

const mediaQueries = [{
    name: 'desktop',
    match: window.matchMedia('(min-width: 992px)')
}, {
    name: 'tablet',
    match: window.matchMedia('(min-width: 576px)')
}, {
    name: 'mobile',
}];

function selectViewPort() {
    for (let i = 0; i < mediaQueries.length; i++) {
        if (!mediaQueries[i].match || mediaQueries[i].match.matches) {
            return mediaQueries[i].name;
        }
    }
    console.warn('No matching media query. Please check you covered all sizes');
}


$(document).on('click', '.film-120-seconds-open', function (ev) {
    ev.preventDefault();
    const $link = $(ev.currentTarget);
    const src = $link.attr(`data-video-${selectViewPort()}`);
    const dialog = new Dialog({
        type: 'video',
        items: [{
            src: src,
        }],
    });

    dialog.$el.on('dialog:ready', () => {
        let video = dialog.$el.find('video')[0];
        video.play();
    });

    dialog.open();
    $link.data('dialog', dialog);
});


function updateVideo(type) {
    $('.film-120-seconds-open').each((_, elem) => {
        const $link = $(elem);
        const src = $link.attr(`data-video-${type}`);

        /** @type {Dialog} */
        const dialog = $link.data('dialog');
        if (!dialog) {
            return;
        }

        const $video = dialog.$el.find('.popup__video');
        /** @type {HTMLVideoElement} */
        const video = $video[0];

        const currentTime = video.currentTime;
        const wasPaused = video.paused;

        video.src = src;
        video.addEventListener('loadeddata', ev => {
            video.currentTime = currentTime;
            wasPaused ? video.pause() : video.play();
        }, {
            once: true,
        });
    });
}

let current = null;
$(window).on('resize', () => {
    let newCurrent = selectViewPort();
    if (current !== newCurrent) {
        current = newCurrent;
        updateVideo(current);
    }

}).trigger('resize');
